import { css } from 'lit';

export const styles = css`
	:host {
		--_sds-checkbox-group-gap: var(--sds-checkbox-group-gap, var(--sds-spacing-xs));
		--_sds-checkbox-group-font-family: var(--sds-checkbox-group-font-family, var(--sds-typography-font-family-roboto));
		--_sds-checkbox-group-font-size: var(--sds-checkbox-group-font-size, var(--sds-components-font-size-content-md));
		--_sds-checkbox-group-text-color: var(--sds-checkbox-group-text-color, var(--sds-color-text-default, var(--sds-color-neutral-text-default)));
		--_sds-checkbox-group-max-line-width: var(--sds-checkbox-group-max-line-width, var(--sds-typography-max-line-width));
		--_sds-checkbox-group-disabled-opacity: var(--sds-checkbox-group-disabled-opacity, var(--sds-color-states-disabled-opacity));

		--_sds-checkbox-group-legend-font-weight: var(--sds-checkbox-group-legend-font-weight, var(--sds-typography-body-lg-strong-tall-desktop-font-weight));
		--_sds-checkbox-group-legend-line-height: var(--sds-checkbox-group-legend-line-height, var(--sds-components-line-height-squeezed-md));
		--_sds-checkbox-group-legend-help-text-gap: var(--sds-checkbox-group-legend-help-text-gap, var(--sds-spacing-4xs));

		--_sds-checkbox-group-help-text-color: var(--sds-checkbox-group-help-text-color, var(--sds-color-text-subtle, var(--sds-color-neutral-text-subtle)));
		--_sds-checkbox-group-help-text-font-size: var(--sds-checkbox-group-help-text-font-size, var(--sds-components-font-size-content-md));
		--_sds-checkbox-group-help-text-font-weight: var(--sds-checkbox-group-help-text-font-weight, var(--sds-typography-body-md-desktop-font-weight));
		--_sds-checkbox-group-help-text-line-height: var(--sds-checkbox-group-help-text-line-height, var(--sds-components-line-height-squeezed-md));

		display: block;
		contain: layout style;
		box-sizing: border-box;
	}

	.sds-checkbox-group {
		border: 0;
		color: var(--_sds-checkbox-group-text-color);
		font-family: var(--_sds-checkbox-group-font-family);
		font-size: var(--_sds-checkbox-group-font-size);
		margin: 0;
		padding: 0;
	}

	.sds-checkbox-group--disabled {
		.sds-checkbox-group__legend,
		.sds-checkbox-group__help-text,
		sds-alert {
			opacity: var(--_sds-checkbox-group-disabled-opacity);
		}
	}

	sds-alert {
		--sds-alert-padding: 0px;
	}

	.sds-checkbox-group__legend {
		display: flex;
		align-items: center;
		gap: var(--sds-spacing-5xs);
		margin: 0;
		padding: 0;
		font-weight: var(--_sds-checkbox-group-legend-font-weight);
		line-height: var(--_sds-checkbox-group-legend-line-height);
		max-width: var(--_sds-checkbox-group-max-line-width);

		+ .sds-checkbox-group__help-text {
			margin-block-start: var(--_sds-checkbox-group-legend-help-text-gap);
		}
	}

	.sds-checkbox-group__help-text {
		color: var(--_sds-checkbox-group-help-text-color);
		font-size: var(--_sds-checkbox-group-help-text-font-size);
		font-weight: var(--_sds-checkbox-group-help-text-font-weight);
		line-height: var(--_sds-checkbox-group-help-text-line-height);
		margin: 0;
		max-width: var(--_sds-checkbox-group-max-line-width);
	}

	.sds-checkbox-group__checkboxes {
		display: flex;
		flex-direction: column;
		gap: var(--_sds-checkbox-group-gap);
		margin-top: var(--_sds-checkbox-group-gap);
	}

	sds-alert {
		margin-top: var(--_sds-checkbox-group-gap);
	}

	:host([size='sm']) {
		--_sds-checkbox-group-font-size: var(--sds-checkbox-group-font-size, var(--sds-components-font-size-content-sm));
		--_sds-checkbox-group-legend-line-height: var(--sds-checkbox-group-legend-line-height, var(--sds-components-line-height-squeezed-sm));
		--_sds-checkbox-group-help-text-font-size: var(--sds-checkbox-group-help-text-font-size, var(--sds-components-font-size-content-sm));
		--_sds-checkbox-group-help-text-line-height: var(--sds-checkbox-group-help-text-line-height, var(--sds-components-line-height-squeezed-sm));
	}

	:host([size='lg']) {
		--_sds-checkbox-group-font-size: var(--sds-checkbox-group-font-size, var(--sds-components-font-size-content-lg));
		--_sds-checkbox-group-legend-line-height: var(--sds-checkbox-group-legend-line-height, var(--sds-components-line-height-squeezed-lg));
		--_sds-checkbox-group-help-text-font-size: var(--sds-checkbox-group-help-text-font-size, var(--sds-components-font-size-content-lg));
		--_sds-checkbox-group-help-text-line-height: var(--sds-checkbox-group-help-text-line-height, var(--sds-components-line-height-squeezed-lg));
	}
`;
